import { Component, Input, OnInit } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import {
  BooleanRulePipe,
  ClassRulePipe,
  DynamicValueComponent,
} from '@softline/dynamic';

@Component({
  selector: 'soft-dynamic-container-value',
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.css'],
  imports: [
    NgTemplateOutlet,
    NgClass,
    ClassRulePipe,
    BooleanRulePipe,
    DynamicValueComponent
],
})
export class ContainerComponent implements OnInit {
  @Input() value?: any;
  @Input() definition: any;

  constructor() {}

  ngOnInit(): void {}
}
